var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._b({attrs:{"items":_vm.journauxDisponibles,"item-text":"libelle","return-object":"","data-testid":_vm.dataTestid},on:{"update:search-input":_vm.updateInputValue},model:{value:(_vm.journal),callback:function ($$v) {_vm.journal=$$v},expression:"journal"}},'v-combobox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }